import { render, staticRenderFns } from "./FreeTime.vue?vue&type=template&id=6606607f&scoped=true"
import script from "./FreeTime.vue?vue&type=script&lang=js"
export * from "./FreeTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6606607f",
  null
  
)

export default component.exports